// extracted by mini-css-extract-plugin
export var footer = "_ri-0";
export var inherit = "_ri-1";
export var input = "_ri-2";
export var modalContent = "_ri-3";
export var quillEditor = "_ri-4";
export var subtitle = "_ri-5";